import { queryTagList } from "@root/graphql/Root.gql";
import { easyMutate, resRest } from "@root/lib/utils";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    async queryTagList({ commit, state, rootState }: any, params: any = null) {
      let {
        data: resData,
        data: {
          api: {
            pageInfo: { totalCount = 0 }
          }
        }
      } = await rootState.gql.query({
        query: queryTagList,
        variables: params
      });

      const list = resData ? resRest(resData) : [];

      return {
        total: totalCount,
        list
      };
    }
  },
  mutations: {
    easyMutate
  }
};
